import { memo, SVGProps } from 'react';

const SvgIcoFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
    <path d="M16 3C8.84999 3 3 8.86044 3 16.0783C3 22.6044 7.75799 28.0211 13.972 29V19.8635H10.67V16.0783H13.972V13.1938C13.972 9.91767 15.909 8.11647 18.886 8.11647C20.303 8.11647 21.785 8.36446 21.785 8.36446V11.5884H20.147C18.535 11.5884 18.028 12.5934 18.028 13.6245V16.0783H21.642L21.057 19.8635H18.028V29C21.0914 28.5143 23.8808 26.945 25.8929 24.5754C27.9049 22.2058 29.0069 19.1921 29 16.0783C29 8.86044 23.15 3 16 3Z" />
  </svg>
);
const Memo = memo(SvgIcoFacebook);
export default Memo;
